import ArticleForm from "../../components/common/article-form/ArticleForm";

export default function Event() {
	return <ArticleForm type="events" />;
}
